/**
 * De volgorde waarin dingen over elkaar heen liggen — één keer, op één plek.
 *
 * Aanleiding: de mediapopup viel weg achter de gele nabootsingsbalk. Dat lag niet aan de
 * mediabibliotheek. Élk venster lag op laag 50, terwijl de kopbalk op 100 en de nabootsingsbalk op
 * 99 liggen; die balken werden dus altijd óver een venster heen getekend. De getallen stonden los
 * door de code heen, dus niemand kon zien dat ze elkaar in de weg zaten — en de zijbalklade deelde
 * laag 50 met de vensters, waardoor de volgorde in de pagina besliste in plaats van een besluit.
 *
 * Van onder naar boven: de zijbalk, de balken bovenaan, de vensters, de meldingen. En daar
 * helemaal boven, buiten deze lijst: de "sla over naar inhoud"-link — zie onderaan.
 *
 * Meldingen liggen bovenop zodat een mededeling niet achter een venster verdwijnt. Let wel: een
 * geopend venster zet de rest van de pagina op non-actief — dat hoort erbij — dus zo'n melding is
 * dan te lezen maar niet aan te klikken.
 */
export const LAGEN = {
  /** De waas achter de zijbalklade op een smal scherm. */
  zijbalkWaas: "z-40",
  /** De zijbalklade zelf. */
  zijbalk: "z-50",
  /** De nabootsingsbalk, direct onder de kopbalk. */
  nabootsingsbalk: "z-[99]",
  /** De kopbalk. */
  kopbalk: "z-[100]",
  /** Elk venster in het portaal. */
  venster: "z-[150]",
  /** De meldingen rechtsboven en rechtsonder. */
  melding: "z-[200]",
} as const;

/**
 * De "sla over naar inhoud"-link ligt boven alles.
 *
 * Hij staat als enige nìet als klasse in de code maar met een kaal getal in het opmaakbestand
 * (`apps/web/src/styles/globals.css`, `.skip-to-content`). Daarom staat hij hier als getal en niet
 * in de lijst hierboven — een klasse die niemand draagt zou een opmaakregel opleveren die nergens
 * gebruikt wordt, en zou dekking suggereren die er niet is. Genoemd omdat hij anders bij een
 * volgende wijziging over het hoofd wordt gezien.
 */
export const OVERSLAAN_LINK_LAAG = 9999;

export type Laag = (typeof LAGEN)[keyof typeof LAGEN];

/** Het getal achter een laag, om de volgorde te kunnen vergelijken. */
export function laagWaarde(laag: string): number {
  const cijfers = laag.match(/\d+/)?.[0];
  return cijfers === undefined ? 0 : Number(cijfers);
}
